export default __webpack_public_path__ + "46c89276a400239090e511e0dc555eac.svg";